// components/TransferTable.js

// used in TransferPage.js

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import axiosInstance from '../../services/axiosInstance';
import { debugLog, logError } from '../../utils/debugUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScaleBalanced, faScaleUnbalanced, faScaleUnbalancedFlip, faChartPie } from '@fortawesome/free-solid-svg-icons';
import {
  getFortnightBankAccounts,
  updateBankAccountReqAmount,
  updateBankAccountAdjustment,
  getRequirementsTotalForBankAccount,
  getBankAccountRequiredAmountHistory,
  deleteBankAccountRequiredAmount,
  findDuplicateBankAccounts,
  getBankAccounts,
  getBankAccountsForFortnight,
  getBalance,
  updateBalance,
} from '../../services/BankAccountService';
import {
  getPays,
  updatePay,
  updatePayBankAccount,
  fetchPaysInSeries,
  updateRemainingAmount,
  calculateUnallocatedAmount,
  updateCanUseRemaining,
  getPayBankAccount,
  updatePayBankAccounts,
  checkSeriesConflictingUnallocated
} from '../../services/PayService';
import { calculateReadableFortnight } from '../../services/DateService';
import { ButtonGroup, Button, Card, Table, Modal, Form, OverlayTrigger, Tooltip, Spinner, Alert } from 'react-bootstrap';
import { BsChevronLeft, BsChevronRight, BsInfoCircle } from 'react-icons/bs';
import { FaEdit, FaEye } from 'react-icons/fa';
import '../../css/TransferTable.css'
import '../../css/Transfers.css'
import { getNextThreeWeeksDates } from '../../utils/dateUtils';
import { roundMoney } from '../../utils/formatters';
import { saveChanges } from '../../utils/saveTransferChanges';
import TransferKey from './TransferKey';
import PhoneTransferView from './PhoneTransferView';
import PhoneLandscapeTransferView from './PhoneLandscapeTransferView';
import FortnightRangeControl from './FortnightRangeControl';
import DuplicateWarning from '../BankAccount/DuplicateWarning';


const TransferTable = ({ isLoading, registerRefresh }) => {
  const [payData, setPayData] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [transferData, setTransferData] = useState({});
  const [editingPay, setEditingPay] = useState(null); // To store which pay is being edited
  // used for payBankAccount and Pay edit modals
  const [payId, setPayId] = useState(null);
  // next 3 used for Pay edit model
  const [payNickname, setPayNickname] = useState(null);
  const [editedPayAmount, setEditedPayAmount] = useState(0);
  const [paySeriesId, setPaySeriesId] = useState(null);
  // next 4 used for Bank Account edit model
  const [bankAccountNickname, setBankAccountNickname] = useState(null);
  const [editedBankAccountReqAmount, setEditedBankAccountReqAmount] = useState(0);
  const [editedBankAccountStartDate, setEditedBankAccountStartDate] = useState(0);
  const [editedBankAccountEndDate, setEditedBankAccountEndDate] = useState(null);
  const [editedBankAccountReason, setEditedBankAccountReason] = useState('');
  const [bankAccountFulfil, setBankAccountFulfil] = useState(null);
  const [choosingDate, setChoosingDate] = useState(false);
  // used for payBankAccount and Bank Account edit modals
  const [bankAccountId, setBankAccountId] = useState(null);
  // next 4 used for edit paybankaccount edit modal
  const [editedTransferOption, setEditedTransferOption] = useState('');
  const [editedTransferAmount, setEditedTransferAmount] = useState('');
  const [editedTransferMade, setEditedTransferMade] = useState('');
//  const [bankAccountId, setBankAccountId] = useState(null);
  const [bankAccountId2, setBankAccountId2] = useState(null); // used for when sending a second bank account ID to the saveChanges method (e.g. unallocated)

  const [displayedData, setDisplayedData] = useState([]);
  const [showPayModal, setShowPayModal] = useState(false); // To control the display of the edit pay modal
  const [showBankAccountModal, setShowBankAccountModal] = useState(false); // To control the display of the edit bank account modal
  const [showModal, setShowModal] = useState(false); // To control the display of the edit transfer modal
  const [applyToAll, setApplyToAll] = useState(false);
  const [unallocatedAmount, setUnallocatedAmount] = useState(0);
  const [isRemainingOptionDisabled, setIsRemainingOptionDisabled] = useState(false);
  const [isUnallocatedOptionDisabled, setIsUnallocatedOptionDisabled] = useState(false);
	const [designatedPayId, setDesignatedPayId] = useState(null);
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [remainingScope, setRemainingScope] = useState('this_pay');
  const [remainingPeriodFrom, setRemainingPeriodFrom] = useState('');
  const [remainingPeriodUntil, setRemainingPeriodUntil] = useState('');
  const [remainingToggleTarget, setRemainingToggleTarget] = useState(null);
  const [remainingToggleValue, setRemainingToggleValue] = useState(false);
  const [remainingToggleBusy, setRemainingToggleBusy] = useState(false);
  const [remainingToggleError, setRemainingToggleError] = useState('');
  const [remainingSeriesPays, setRemainingSeriesPays] = useState([]);
  const [remainingPreviewLoading, setRemainingPreviewLoading] = useState(false);
  const [pay, setPay] = useState({ canUseRemaining: false });
  const [editTransfers, setEditTransfers] = useState(false);
  const [fortnightStart, setFortnightStart] = useState('');
  const [formattedRangeFortnight, setFormattedRangeFortnight] = useState('');
  const [fortnightIndex, setFortnightIndex] = useState(0);
  // defined here as cannot define in saveTransferChanges.js as it only contains a function
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [conflictingTransfers, setConflictingTransfers] = useState([]);
  const [showAmounts, setShowAmounts] = useState(false);
  // New state variables for adjustment
  const [requirementsTotal, setRequirementsTotal] = useState(0);
  const [adjustmentAmount, setAdjustmentAmount] = useState(0);
  const [adjustmentReason, setAdjustmentReason] = useState('');
  const [currentBankAccount, setCurrentBankAccount] = useState(null);
  // next 3 define amount change scope options
  const [amountChangeScope, setAmountChangeScope] = useState('one_fortnight');
  const [amountChangeDuration, setAmountChangeDuration] = useState(1);
  const [showAmountHistory, setShowAmountHistory] = useState(false);
  const [amountHistory, setAmountHistory] = useState([]);
  // State to trigger re-renders after data updates
  const [updateTrigger, setUpdateTrigger] = useState(0);
  // State to manage loading state for bank account updates 
  const [isUpdatingBankAccount, setIsUpdatingBankAccount] = useState(false);
  const [bankAccountSaveError, setBankAccountSaveError] = useState('');
  // State to manage loading state for pay bank account updates
  const [isUpdatingPayBankAccount, setIsUpdatingPayBankAccount] = useState(false);
  // State for handling conflicting unallocated transfers
  const [showUnallocatedConflictModal, setShowUnallocatedConflictModal] = useState(false);
  const [conflictingUnallocatedTransfers, setConflictingUnallocatedTransfers] = useState([]);
  const [pendingSaveData, setPendingSaveData] = useState(null);
  // Add this new state to store formatted date ranges
  const [payDateFormatted, setPayDateFormatted] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  
  // Mobile phone specific state
  const [isPhone, setIsPhone] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [currentPayIndex, setCurrentPayIndex] = useState(0);
  const [showMobileAccountOverlay, setShowMobileAccountOverlay] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  
  // Swipe navigation state
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [swipeDirection, setSwipeDirection] = useState(null);



  // Add this function just below the totalFortnightlyRequirements constant near the beginning of the component
  // Add around line 64, before the useState declarations
  const stopPropagation = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
  };

  // Check if device is mobile / phone (matchMedia for reliable iOS orientation)
  useEffect(() => {
    const landscapeQuery = window.matchMedia('(orientation: landscape)');

    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setIsMobile(width <= 768);

      const isPhonePortrait = width <= 480;
      const isPhoneLandscape = height <= 480 && width <= 896;
      setIsPhone(isPhonePortrait || isPhoneLandscape);

      setIsLandscape(landscapeQuery.matches);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    landscapeQuery.addEventListener('change', checkDevice);

    return () => {
      window.removeEventListener('resize', checkDevice);
      landscapeQuery.removeEventListener('change', checkDevice);
    };
  }, []);

  // Swipe navigation handlers for fortnight (desktop)
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      setSwipeDirection(null);
      return;
    }
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      // Swipe left - go to next fortnight
      setSwipeDirection('left');
      setTimeout(() => {
        setFortnightIndex((prevIndex) => prevIndex + 1);
        setSwipeDirection(null);
      }, 200);
    } else if (isRightSwipe) {
      // Swipe right - go to previous fortnight
      setSwipeDirection('right');
      setTimeout(() => {
        setFortnightIndex((prevIndex) => Math.max(0, prevIndex - 1));
        setSwipeDirection(null);
      }, 200);
    } else {
      setSwipeDirection(null);
    }
  };

  // Show floating buttons on scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingButtons(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Create a refresh function that can be called from the parent
  const refreshData = useCallback(async () => {
    try {
      await fetchPayData(fortnightIndex);
      await fetchBankAccounts(fortnightIndex);
    } catch (error) {
      logError('refreshing data', error);
    }
  }, [fortnightIndex]);

  // Create a function to refresh just bank accounts that can be called from other components
  const refreshBankAccounts = useCallback(async () => {
    try {
      await fetchBankAccounts(fortnightIndex);
    } catch (error) {
      logError('refreshing bank accounts', error);
    }
  }, [fortnightIndex]);

  // Expose a global refresh that updates BOTH pays and bank accounts.
  // RequirementService.refreshBankAccountsData() calls this so that saving
  // a requirement also refreshes the remaining-transfer amounts shown in the table.
  useEffect(() => {
    window.refreshBankAccounts = refreshData;
    return () => {
      delete window.refreshBankAccounts;
    };
  }, [refreshData]);

  // Register the refresh function with the parent component
  useEffect(() => {
    if (registerRefresh) {
      registerRefresh(refreshData);
    }
  }, [registerRefresh, refreshData]);

  // Also add a useEffect to refresh data when the component mounts
  useEffect(() => {
    refreshData();
  }, [refreshData]);

  useEffect(() => {
    const fetchData = async (relativeFortnightIndex = 0) => {
      try {
        const result = await calculateReadableFortnight(fortnightIndex);
        setFortnightStart(new Date(result[0]));
        setFormattedRangeFortnight(result[1]);
      } catch (error) {
        logError('fetching fortnight data', error);
      }
    };

    fetchData();
  }, [fortnightIndex]);

  const showNextFortnight = () => {
    setFortnightIndex((prevIndex) => prevIndex + 1);
  };

  const showPreviousFortnight = () => {
    setFortnightIndex((prevIndex) => Math.max(0, prevIndex - 1));
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchPayData(fortnightIndex);
        await fetchBankAccounts(fortnightIndex);
      } catch (error) {
        logError('fetching data', error);
      }
    };

    fetchData();
  }, [fortnightIndex, updateTrigger]);

  const fetchPayData = async (relativeFortnightIndex = 0) => {
    try {
      const response = await axiosInstance.get(`/get-pays-in-fortnight/?relative_fortnight_index=${relativeFortnightIndex}`);
      const sortedPayData = response.data.sort((a, b) => a.next_pay.localeCompare(b.next_pay));
      setPayData(sortedPayData);
      setDisplayedData(sortedPayData);
    } catch (error) {
      logError('fetching pay data', error);
    }
  };

    // Define updateDisplayedData function
    const updateDisplayedData = (callback) => {
      setDisplayedData((prevData) => {
        // Apply the callback to the previous data
        const updatedData = callback(prevData);
        // Return the updated data to setDisplayedData
        return updatedData;
      });
    };

  const fetchBankAccounts = async (relativeFortnightIndex = 0) => {
    try {
      const response = await axiosInstance.get(`/get-bank-accounts-in-fortnight/?relative_fortnight_index=${relativeFortnightIndex}`);
      setBankAccounts(response.data);
    } catch (error) {
      logError('fetching bank accounts', error);
    }
  };

//  // Calculate total required amount per fortnight
//  const totalRequiredAmount = bankAccounts.reduce((total, account) => {
//    if (account.fulfil === 'weekly') {
//      total += account.required_amount * 2; // Weekly required_amount is multiplied by 2 for fortnightly
//    } else if (account.fulfil === 'fortnightly') {
//      total += account.required_amount;
//    }
//    return total;
//  }, 0);


	// Calculate the total fortnightly requirements of all accounts combined
	const totalFortnightlyRequirements = useMemo(() => {
		return bankAccounts.reduce((total, account) => {
			// Backend now provides the correct fortnightly amount, no conversion needed
			total += parseFloat(account.required_amount);
			return total;
		}, 0);
	}, [bankAccounts]); // Recalculate when bankAccounts changes

  useEffect(() => {
  }, [payId, bankAccountId]);

  const remainingPreviewCount = useMemo(() => {
    if (!remainingToggleTarget) return 0;
    if (remainingScope === 'this_pay') return 1;

    const from = remainingScope === 'pay_period'
      ? remainingPeriodFrom
      : remainingToggleTarget.next_pay;
    const to = remainingScope === 'pay_period' ? remainingPeriodUntil : null;
    if (!from || (remainingScope === 'pay_period' && !to)) return 0;

    return remainingSeriesPays.filter((p) => {
      if (p.pay_series_id !== remainingToggleTarget.pay_series_id) return false;
      if (remainingScope === 'this_and_future') {
        return p.next_pay >= remainingToggleTarget.next_pay;
      }
      return p.next_pay >= from && p.next_pay <= to;
    }).length;
  }, [remainingPeriodFrom, remainingPeriodUntil, remainingScope, remainingSeriesPays, remainingToggleTarget]);

  const handleToggleDesignatedPay = (pay) => {
    setRemainingToggleTarget(pay);
    setRemainingToggleValue(!pay.canUseRemaining);
    setRemainingScope('this_pay');
    setRemainingPeriodFrom(pay.next_pay || '');
    setRemainingPeriodUntil('');
    setRemainingToggleError('');
    setShowConfirmationModal(true);
    setRemainingPreviewLoading(true);
    fetchPaysInSeries(pay.id)
      .then((pays) => setRemainingSeriesPays(pays))
      .catch((error) => {
        setRemainingSeriesPays([pay]);
        logError('fetching pays in series for Allow Remaining preview', error);
      })
      .finally(() => setRemainingPreviewLoading(false));
  };

  const handleConfirmToggleDesignatedPay = async () => {
    if (!remainingToggleTarget || remainingToggleBusy) return;
    setRemainingToggleBusy(true);
    setRemainingToggleError('');
    try {
      const body = {
        pay_id: remainingToggleTarget.id,
        scope: remainingScope,
      };
      if (remainingScope === 'pay_period') {
        if (!remainingPeriodFrom || !remainingPeriodUntil) {
          setRemainingToggleError('Choose a from date and to date for the period.');
          return;
        }
        body.period_start_date = remainingPeriodFrom;
        body.period_until_date = remainingPeriodUntil;
      }
      await updateCanUseRemaining(
        remainingToggleTarget.pay_series_id,
        remainingToggleValue,
        body,
      );
      setShowConfirmationModal(false);
      await fetchPayData(fortnightIndex);
    } catch (error) {
      const data = error.response?.data;
      const msg = data
        ? (data.canUseRemaining || data.period_until_date || data.scope || data.detail || Object.values(data)[0])
        : 'Unable to update Allow Remaining.';
      setRemainingToggleError(Array.isArray(msg) ? msg[0] : String(msg));
      logError('updating canUseRemaining field', error);
    } finally {
      setRemainingToggleBusy(false);
    }
  };

	// confirm transfer_made or not made with the tick/cross button
	const handleButtonClick = async (PayBankAccount) => {
		// Determine the new value for transfer_made based on the current value
		const newTransferMade = !PayBankAccount.transfer_made;
		const wasPaid = PayBankAccount.transfer_made;
		const isPaid = newTransferMade;

		// Extract payId, bankAccountId, transferOption, and transferAmount from PayBankAccount
		const payId = PayBankAccount.pay;
		const bankAccountId = PayBankAccount.bank_account;
		const transferOption = PayBankAccount.transfer_option;
		const transferAmount = parseFloat(PayBankAccount.transfer_amount);

    // Update the local state immediately
    setPayData(prevPayData =>
      prevPayData.map(pay => {
        if (pay.id === payId) {
          return {
            ...pay,
            bank_accounts: pay.bank_accounts.map(ba => {
              if (ba.bank_account === bankAccountId) {
                return { ...ba, transfer_made: newTransferMade };
              }
              return ba;
            })
          };
        }
        return pay;
      })
    );

		try {
			// Call the API to update the PayBankAccount with the new transfer_made value
			await updatePayBankAccount(payId, bankAccountId, transferOption, transferAmount, newTransferMade);
			
			// Update the bank account balance if paid status changed and transfer amount > 0
			if (wasPaid !== isPaid && transferAmount > 0) {
				try {
					// Get the current balance for the bank account
					const bankAccountBalance = await getBalance(bankAccountId);
					const currentBalanceAmount = parseFloat(bankAccountBalance.amount);
					
					// For transfers: add when paid, subtract when unpaid
					const newBalance = isPaid ? 
						currentBalanceAmount + transferAmount : 
						currentBalanceAmount - transferAmount;
					
					// Format the amount as a string with 2 decimal places
					const formattedNewBalance = newBalance.toFixed(2);
					
					// Update the balance for the bank account
					await updateBalance(bankAccountBalance.id, {
						amount: formattedNewBalance,
						bank_account: bankAccountId,
						update_date: new Date().toISOString().split('T')[0]
					});
					

				} catch (balanceError) {
					logError('updating bank account balance after transfer status change', balanceError);
					// Continue even if balance update fails - the transfer status was still updated
				}
			}
		} catch (error) {
			// Handle errors - revert the local state change
			logError('updating PayBankAccount', error);
			setPayData(prevPayData =>
				prevPayData.map(pay => {
					if (pay.id === payId) {
						return {
							...pay,
							bank_accounts: pay.bank_accounts.map(ba => {
								if (ba.bank_account === bankAccountId) {
									return { ...ba, transfer_made: wasPaid }; // Revert to original state
								}
								return ba;
							})
						};
					}
					return pay;
				})
			);
		}
	};

// next two code blocks for updating pay amounts
  const handlePayClick= (pay) => {
  	if (editTransfers) {
			setPayId(pay.id);
			setPaySeriesId(pay.pay_series_id);
			setPayNickname(pay.nickname);
			setEditedPayAmount(pay.amount);
			setShowPayModal(true);

			// Check if there is any PayBankAccount for the current pay with transfer_option = 'unallocated'
      const allPays = getPays();
    }
  };

  const updatePayClick = async (payId) => {
    try {
      setIsUpdatingPayBankAccount(true); // Show loading state

      // Update the pay in the database with the correct logic for applyToAll
      if (applyToAll) {
        await updatePay(payId, editedPayAmount, paySeriesId);
      } else {
        await updatePay(payId, editedPayAmount, null);
      }

      // Update both state variables consistently
      const updatePayState = (prevData) =>
        prevData.map((pay) => {
          if (pay.id === payId) {
            return { ...pay, amount: editedPayAmount };
          }
          return pay;
        });

      setPayData(updatePayState);
      setDisplayedData(updatePayState);

      // Fetch fresh data to get all cascading updates including unallocated transfers
      try {
        await fetchPayData(fortnightIndex);
        await fetchBankAccounts(fortnightIndex);
      } catch (refreshError) {
        debugLog('Error refreshing data after pay update:', refreshError.name);
        // Continue even if refresh fails - we've already updated local state
      }
    } catch (error) {
      logError('updating pay', error);
    } finally {
      setShowPayModal(false); // Always close the modal, even if there was an error
      setIsUpdatingPayBankAccount(false); // Hide loading state
    }
  };


//  const updatePayClick = (payId) => {
//    if (applyToAll) {
//      updatePay(payId, editedPayAmount, paySeriesId);
//    } else {
//      updatePay(payId, editedPayAmount, null);
//    }
//
//    // Update the displayed data immediately after the update
//    setDisplayedData((prevData) =>
//        prevData.map((pay) => {
//            if (pay.id === payId) {
//                return { ...pay, amount: editedPayAmount };
//            }
//            return pay;
//        })
//    );
//
//    setShowPayModal(false); // Close the modal
//  };

// next 4 code blocks for updating bank account req amounts
  const handleBankAccountClick = async (bankAccount) => {
    if (editTransfers) {
      try {
        setBankAccountId(bankAccount.id);
        setBankAccountNickname(bankAccount.nickname);
        setBankAccountFulfil(bankAccount.fulfil);
        setCurrentBankAccount(bankAccount);
        setAmountChangeScope('one_fortnight');
        setAmountChangeDuration(1);
        setEditedBankAccountEndDate(null);
        setEditedBankAccountReason('');
        
        // Fetch requirements total for this bank account
        const result = await getRequirementsTotalForBankAccount(bankAccount.id, fortnightIndex);
        
        // Ensure requirementsTotal is always a number
        const reqTotal = parseFloat(result.requirements_total ?? result.calculated_amount ?? 0) || 0;
        setRequirementsTotal(reqTotal);
        
        // Set adjustment amount and reason from bank account data
        const adjAmount = typeof bankAccount.adjustment_amount === 'number' ? 
                         bankAccount.adjustment_amount : 
                         parseFloat(bankAccount.adjustment_amount || 0);
        setAdjustmentAmount(adjAmount);
        
        setAdjustmentReason(bankAccount.adjustment_reason || '');
        
        // Calculate the total required amount (requirements + adjustment)
        const calculatedTotal = reqTotal + adjAmount;
        
        setEditedBankAccountReqAmount(calculatedTotal);
        
        setEditedBankAccountStartDate(getFortnightStart());

        // Fetch amount history
        try {
          const history = await getBankAccountRequiredAmountHistory(bankAccount.id);
          setAmountHistory(history);
        } catch (error) {
          logError('fetching required amount history', error);
          setAmountHistory([]);
        }
        
        // Show the modal
        setBankAccountSaveError('');
        setShowBankAccountModal(true);
      } catch (error) {
        logError('fetching requirements total', error);
      }
    }
  };

  // Function to get fortnightStart's date
  const getFortnightStart = () => {
    return fortnightStart instanceof Date ? fortnightStart.toISOString().split('T')[0] : '';
  };

  // Function to get fortnight end date (13 days after start)
  const getFortnightEnd = (startDate) => {
    if (!startDate) return '';
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + 13);
    return end.toISOString().split('T')[0];
  };

  // Get array of available fortnight start dates
  const getFortnightStartOptions = () => {
    if (!fortnightStart || !(fortnightStart instanceof Date)) return [];
    
    const currentFortnightStart = new Date(fortnightStart);
    const options = [];
    
    // Add past fortnights (up to 6 months back)
    for (let i = -12; i <= 0; i++) {
      const date = new Date(currentFortnightStart);
      date.setDate(currentFortnightStart.getDate() + (i * 14));
      options.push({
        value: date.toISOString().split('T')[0],
        label: date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
      });
    }
    
    // Add future fortnights (up to 6 months ahead)
    for (let i = 1; i <= 12; i++) {
      const date = new Date(currentFortnightStart);
      date.setDate(currentFortnightStart.getDate() + (i * 14));
      options.push({
        value: date.toISOString().split('T')[0],
        label: date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
      });
    }
    
    return options;
  };

  // Calculate the fortnight index from a date relative to the current fortnight
  const calculateFortnightIndex = (dateStr) => {
    if (!dateStr || !fortnightStart || !(fortnightStart instanceof Date)) return 0;
    
    const date = new Date(dateStr);
    const diffTime = date - fortnightStart;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.floor(diffDays / 14);
  };

  // Calculate the end date based on the start date and duration
  const calculateEndDate = (startDate, durationFortnights, isIndefinite = false) => {
    if (isIndefinite) return null;
    if (!startDate) return '';
    
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + (durationFortnights * 14) - 1); // Last day of the last fortnight
    return end.toISOString().split('T')[0];
  };



const updateBankAccountClick = async (bankAccountId) => {
    setBankAccountSaveError('');
    setIsUpdatingBankAccount(true);

    try {
      let endDate = null;

      if (amountChangeScope === 'one_fortnight') {
        const startDate = new Date(editedBankAccountStartDate);
        const endDateObj = new Date(startDate);
        endDateObj.setDate(startDate.getDate() + 13);
        endDate = endDateObj.toISOString().split('T')[0];
      } else if (amountChangeScope === 'multiple_fortnights') {
        const startDate = new Date(editedBankAccountStartDate);
        const endDateObj = new Date(startDate);
        endDateObj.setDate(startDate.getDate() + (amountChangeDuration * 14) - 1);
        endDate = endDateObj.toISOString().split('T')[0];
      }

      const apiAmount = roundMoney(editedBankAccountReqAmount);
      const apiAmountNum = parseFloat(apiAmount);

      if (isNaN(apiAmountNum)) {
        setBankAccountSaveError('Please enter a valid required amount.');
        return;
      }

      // Single save: sets total + derived adjustment and recalculates remaining transfers
      await updateBankAccountReqAmount(
        bankAccountId,
        apiAmountNum,
        editedBankAccountStartDate,
        endDate,
        editedBankAccountReason || adjustmentReason
      );

      setShowBankAccountModal(false);

      await fetchBankAccounts(fortnightIndex);
      await fetchPayData(fortnightIndex);
      setUpdateTrigger(prev => prev + 1);
    } catch (error) {
      logError('updating bank account', error);
      const msg = error.response?.data?.error
        || error.response?.data?.detail
        || 'Unable to save. Please try again.';
      setBankAccountSaveError(msg);
    } finally {
      setIsUpdatingBankAccount(false);
    }
};

  // Function to get the start date of the next fortnight
  const getNextFortnightStart = () => {
    const nextFortnightStart = new Date(fortnightStart);
    nextFortnightStart.setDate(fortnightStart.getDate() + 14);
    return nextFortnightStart.toISOString().split('T')[0]; // Return the start date of the next fortnight in 'YYYY-MM-DD' format
  };


// next two code blocks for updating Pay Bank Accounts
  const handleCellClick = async (payBankAccount, payId) => {
  	if (editTransfers) {
			try {
				// Check if the selected pay is the designated pay
				const isDesignatedPay = payId === designatedPayId;
				
				// Check if there is any PayBankAccount for the current pay with transfer_option = 'unallocated'
				const unallocatedResponse = await axiosInstance.get(
					`/pays/${payBankAccount.pay}/${payBankAccount.bank_account}/check-unallocated-pay/`
				);
				
				const hasUnallocatedPay = unallocatedResponse.data.has_unallocated_pay;
				const unallocatedBankAccounts = unallocatedResponse.data.unallocated_bank_accounts;
				
				setIsUnallocatedOptionDisabled(hasUnallocatedPay);
				
				if (hasUnallocatedPay && unallocatedBankAccounts.length > 0) {
					const bankAccountId2 = unallocatedBankAccounts[0]; // Extract the first element from the array
					setBankAccountId2(bankAccountId2); // Set the state variable with the selected bank account ID
				}
				
				// Check if there is any PayBankAccount with transfer_option = 'remaining'
				const remainingResponse = await axiosInstance.get(
					`/pays/${payBankAccount.pay}/bank-accounts/${payBankAccount.bank_account}/check-remaining-pay/`
				);
				
				const hasRemainingPay = remainingResponse.data.hasRemainingPay;
				const payCanUseRemaining = remainingResponse.data.canUseRemaining;
				
				// Determine whether to disable the 'Remaining' option and set the appropriate message
				const isRemainingOptionDisabled = !payCanUseRemaining;
				setIsRemainingOptionDisabled(isRemainingOptionDisabled);
				
				// Set the state variables and open the modal
				setPayId(payId);
				setBankAccountId(payBankAccount.bank_account);
				setEditedTransferOption(payBankAccount.transfer_option);
				setEditedTransferAmount(payBankAccount.transfer_amount);
				setEditedTransferMade(payBankAccount.transfer_made);
				setShowModal(true); // Show the modal
			} catch (error) {
				logError('checking pay options', error);
				// Show error message to user
				alert('Please try again.');
			}
		}
	};

  const saveChangesWrapper = async (payId) => {
    try {
      setIsUpdatingPayBankAccount(true);

      // Check if we're changing to or from 'unallocated' or 'remaining'
      // This helps the backend handle cascading updates properly
      const previousTransferOption = payData
        .flatMap(pay => pay.bank_accounts)
        .find(ba => ba.pay === payId && ba.bank_account === bankAccountId)?.transfer_option;
      
      const isChangingToUnallocated = previousTransferOption !== 'unallocated' && editedTransferOption === 'unallocated';
      const isChangingFromUnallocated = previousTransferOption === 'unallocated' && editedTransferOption !== 'unallocated';
      const isChangingToRemaining = previousTransferOption !== 'remaining' && editedTransferOption === 'remaining';
      const isChangingFromRemaining = previousTransferOption === 'remaining' && editedTransferOption !== 'remaining';
      
      // If we're changing to unallocated AND applying to all pays in series, check for conflicts
      if (isChangingToUnallocated && applyToAll) {
        try {
          // Import the checkSeriesConflictingUnallocated function if not already imported
          const { checkSeriesConflictingUnallocated } = await import('../../services/PayService');
          
          // Check for conflicting unallocated transfers
          const conflictResult = await checkSeriesConflictingUnallocated(payId, bankAccountId);
          
          if (conflictResult.hasConflicts) {
            // Store the conflicts and the data we want to save
            setConflictingUnallocatedTransfers(conflictResult.conflictingTransfers);
            setPendingSaveData({
              payId,
              bankAccountId,
              editedTransferOption,
              editedTransferAmount,
              editedTransferMade,
              applyToAll,
              isChangingToUnallocated,
              isChangingFromUnallocated,
              isChangingToRemaining,
              isChangingFromRemaining,
              previousTransferOption
            });
            
            // Show the confirmation modal
            setShowUnallocatedConflictModal(true);
            setIsUpdatingPayBankAccount(false); // End loading state since we're waiting for user input
            return; // Exit early - we'll continue after user confirmation
          }
        } catch (error) {
          logError('checking for conflicting unallocated transfers', error);
          // Continue with the save operation even if the conflict check fails
        }
      }
      
      // Prepare the data for saving
      const data = {
        pay_ids: [payId],
        bank_account_id: bankAccountId,
        transfer_option: editedTransferOption,
        transfer_amount: editedTransferAmount,
        transfer_made: editedTransferMade,
        update_all: applyToAll,
        // No conflicts or user confirmed, so don't convert anything
        convert_conflicting_unallocated: false,
        // Add metadata to help backend handle special cases
        option_change_metadata: {
          previous_option: previousTransferOption,
          is_changing_to_unallocated: isChangingToUnallocated,
          is_changing_from_unallocated: isChangingFromUnallocated,
          is_changing_to_remaining: isChangingToRemaining,
          is_changing_from_remaining: isChangingFromRemaining
        }
      };

      // First make the API call to update the transfer
      await updatePayBankAccounts(payId, data);

      // Add a small delay to ensure backend calculations complete
      await new Promise(resolve => setTimeout(resolve, 300));

      // Then fetch fresh data to get all cascading updates
      await Promise.all([
        fetchPayData(fortnightIndex),
        fetchBankAccounts(fortnightIndex)
      ]);

      setEditingPay(null); // Exit editing mode
      setShowModal(false); // Close the modal
      
      // Wait a short time to ensure all updates are processed
      setTimeout(() => {
        setIsUpdatingPayBankAccount(false); // End loading state
        setUpdateTrigger(prev => prev + 1); // Force UI update
      }, 500);
    } catch (error) {
      logError('[TransferTable] saveChangesWrapper', error);
      setIsUpdatingPayBankAccount(false);
    }
  };
  
  // Function to handle confirmation of converting conflicting unallocated transfers
  const handleConfirmConvertUnallocated = async () => {
    try {
      setIsUpdatingPayBankAccount(true); // Set loading state to true
      setShowUnallocatedConflictModal(false); // Close the confirmation modal
      
      if (!pendingSaveData) {
        debugLog('No pending save data found');
        setIsUpdatingPayBankAccount(false);
        return;
      }
      
      // Extract data from pendingSaveData
      const { 
        payId, 
        bankAccountId, 
        editedTransferOption, 
        editedTransferAmount, 
        editedTransferMade, 
        applyToAll,
        previousTransferOption,
        isChangingToUnallocated,
        isChangingFromUnallocated,
        isChangingToRemaining,
        isChangingFromRemaining
      } = pendingSaveData;
      
      // Prepare the data for saving, setting convert_conflicting_unallocated to true
      const data = {
        pay_ids: [payId],
        bank_account_id: bankAccountId,
        transfer_option: editedTransferOption,
        transfer_amount: editedTransferAmount,
        transfer_made: editedTransferMade,
        update_all: applyToAll,
        // User confirmed, so convert conflicting unallocated transfers
        convert_conflicting_unallocated: true,
        // Add metadata to help backend handle special cases
        option_change_metadata: {
          previous_option: previousTransferOption,
          is_changing_to_unallocated: isChangingToUnallocated,
          is_changing_from_unallocated: isChangingFromUnallocated,
          is_changing_to_remaining: isChangingToRemaining,
          is_changing_from_remaining: isChangingFromRemaining
        }
      };
      
      await updatePayBankAccounts(payId, data);
      
      // For unallocated changes, we need to wait a bit longer to ensure
      // all cascading calculations complete before fetching fresh data
      if (isChangingToUnallocated || isChangingFromUnallocated || 
          isChangingToRemaining || isChangingFromRemaining) {
        await new Promise(resolve => setTimeout(resolve, 300));
      }
  
      // Fetch fresh data to get all cascading updates
      await Promise.all([
        fetchPayData(fortnightIndex),
        fetchBankAccounts(fortnightIndex)
      ]);
      
      setEditingPay(null); // Exit editing mode
      setShowModal(false); // Close the edit modal
      setPendingSaveData(null); // Clear pending save data
      
      // Wait a short time to ensure all updates are processed
      setTimeout(() => {
        setIsUpdatingPayBankAccount(false); // End loading state
        setUpdateTrigger(prev => prev + 1); // Force UI update
      }, 500);
    } catch (error) {
      logError('saving changes after conflict resolution', error);
      setIsUpdatingPayBankAccount(false); // End loading state on error
      setPendingSaveData(null); // Clear pending save data
    }
  };
  
  // Function to cancel the unallocated conflict resolution
  const handleCancelConvertUnallocated = () => {
    setShowUnallocatedConflictModal(false);
    setPendingSaveData(null);
  };

  // Only characters that form a valid in-progress decimal are accepted:
  //   optional leading minus, digits, at most one decimal point.
  const DECIMAL_INPUT_RE = /^-?\d*\.?\d*$/;

  const handleAdjustmentChange = (value) => {
    // Reject anything that doesn't look like a numeric value being typed
    if (value !== '' && !DECIMAL_INPUT_RE.test(value)) return;

    setAdjustmentAmount(value);

    const parsed = parseFloat(value);
    const newAdjustment = isNaN(parsed) ? 0 : parsed;
    const reqTotal = typeof requirementsTotal === 'number' ? requirementsTotal : 0;
    setEditedBankAccountReqAmount(reqTotal + newAdjustment);
  };

  // Function to format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'Indefinite';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  // Function to handle deletion of a required amount record
  const handleDeleteRequiredAmount = async (requiredAmountId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await deleteBankAccountRequiredAmount(requiredAmountId);
        // Refresh history after deletion
        const history = await getBankAccountRequiredAmountHistory(bankAccountId);
        setAmountHistory(history);
        // Refresh the main data
        await fetchBankAccounts(fortnightIndex);
      } catch (error) {
        logError('deleting required amount record', error);
      }
    }
  };

  // Replace the existing useEffect
  const loadFormattedDates = useCallback(async () => {
    const pendingDates = [];
    
    // First collect all dates we need to fetch without updating state
    for (const transfer of conflictingUnallocatedTransfers) {
      if (transfer.pay_date && !payDateFormatted[transfer.pay_date]) {
        pendingDates.push(transfer.pay_date);
      }
    }
    
    // If no dates to fetch, exit early
    if (pendingDates.length === 0) return;
    
    // Create a batch of updates to make a single state update at the end
    const updates = {};
    
    // Process each date
    for (const date of pendingDates) {
      try {
        const result = await calculateReadableFortnight(date);
        updates[date] = result[1]; // Store the formatted date range
      } catch (error) {
        logError("formatting pay date", error);
        updates[date] = "Error loading date";
      }
    }
    
    // Only update state once with all the new formatted dates
    if (Object.keys(updates).length > 0) {
      setPayDateFormatted(prev => ({
        ...prev,
        ...updates
      }));
    }
  }, [conflictingUnallocatedTransfers]); // Only depends on the transfers array, not payDateFormatted

  // Add back the useEffect that uses loadFormattedDates
  useEffect(() => {
    // Only run if we have transfers that need formatting
    if (conflictingUnallocatedTransfers.length > 0) {
      loadFormattedDates();
    }
  }, [conflictingUnallocatedTransfers, loadFormattedDates]);



  const showPhonePortrait = isPhone && !isLandscape;
  const showPhoneLandscape = isPhone && isLandscape;
  const showPhoneLayout = showPhonePortrait || showPhoneLandscape;

  const handleJumpToCurrentFortnight = () => {
    setCurrentPayIndex(0);
  };

	return (
		<div>
			{/* Loading overlay */}
			{(isLoading || isUpdatingBankAccount || isUpdatingPayBankAccount) && (
				<div className="loading-overlay" style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					zIndex: 9999
				}}>
					<div className="loading-spinner" style={{
						padding: '20px',
						backgroundColor: 'white',
						borderRadius: '5px',
						boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)'
					}}>
						Processing transfers... Please wait.
					</div>
				</div>
			)}
			<Card.Body
        className={
          showPhonePortrait
            ? 'transfer-table-body--phone-portrait'
            : showPhoneLandscape
            ? 'transfer-table-body--phone-landscape'
            : undefined
        }
      >
			  {!showPhoneLayout && (
			  <div className="transfers-desktop-fortnight-header" style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2 style={{ 
              fontSize: isMobile ? "20px" : "24px", 
              fontWeight: "bold", 
              borderBottom: "2px solid #A0C2BB", 
              display: "inline-block", 
              paddingBottom: "10px",
              marginBottom: isMobile ? "10px" : "15px"
            }}>
            Transfers
          </h2>
          <div className="transfers-desktop-fortnight-row" style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            flexWrap: isMobile ? "wrap" : "nowrap",
            gap: isMobile ? "10px" : "20px",
            marginBottom: isMobile ? "10px" : "15px"
          }}>
            <span style={{ 
              fontSize: isMobile ? "14px" : "18px", 
              color: "#555",
              marginBottom: isMobile ? "5px" : "0"
            }}>
              for fortnight:
            </span>
            <FortnightRangeControl
              formattedRangeFortnight={formattedRangeFortnight}
              fortnightIndex={fortnightIndex}
              setFortnightIndex={setFortnightIndex}
              onJumpToCurrent={handleJumpToCurrentFortnight}
              className="transfers-desktop-fortnight-nav"
              rangeClassName="transfers-desktop-fortnight-range"
            />
          </div>
        </div>
          )}

        {showPhonePortrait && (
          <PhoneTransferView
            payData={payData}
            bankAccounts={bankAccounts}
            currentPayIndex={currentPayIndex}
            setCurrentPayIndex={setCurrentPayIndex}
            fortnightIndex={fortnightIndex}
            setFortnightIndex={setFortnightIndex}
            formattedRangeFortnight={formattedRangeFortnight}
            editTransfers={editTransfers}
            setEditTransfers={setEditTransfers}
            onTogglePaid={handleButtonClick}
            onCellEditClick={handleCellClick}
            onJumpToCurrentFortnight={handleJumpToCurrentFortnight}
          />
        )}

        {showPhoneLandscape && (
          <PhoneLandscapeTransferView
            payData={payData}
            bankAccounts={bankAccounts}
            fortnightIndex={fortnightIndex}
            setFortnightIndex={setFortnightIndex}
            formattedRangeFortnight={formattedRangeFortnight}
            editTransfers={editTransfers}
            setEditTransfers={setEditTransfers}
            onTogglePaid={handleButtonClick}
            onCellEditClick={handleCellClick}
            onJumpToCurrentFortnight={handleJumpToCurrentFortnight}
          />
        )}

        <div 
          className={`transfer-table-container ${swipeDirection ? `swipe-${swipeDirection}` : ''} ${showPhoneLayout ? 'transfer-table-container--phone-portrait-hidden' : ''}`}
        >
          <Table
            className={`transfer-table ${showAmounts ? 'table-amounts-expanded' : 'table-amounts-collapsed'}`}
            striped
            bordered={false}
            hover
            style={{ textAlign: "center" }}
          >
            <thead>
              <tr className="header-row">
                <th style={{ verticalAlign: "middle" }}>Account Name</th>
                <th style={{ verticalAlign: "middle" }}>
                  <span>Fortnightly Req.</span>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>
                        Required amount per fortnight
                      </Tooltip>
                    }
                  >
                    <span style={{ marginLeft: '5px', cursor: 'help' }}>
                      <BsInfoCircle size={12} />
                    </span>
                  </OverlayTrigger>
                </th>
                <th
                  colSpan="2"
                  style={{
                    cursor: 'pointer',
                    verticalAlign: 'middle',
                    height: '100%'
                  }}
                  onClick={() => setShowAmounts(!showAmounts)}
                >
                  {showAmounts ? (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto' }}>
                      <span>Actual Amount</span>
                      <span>Difference</span>
                      <span style={{ fontSize: '0.8em', marginLeft: '6px' }}>◀</span>
                    </div>
                  ) : (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '2px'
                    }}>
                      <FontAwesomeIcon
                        icon={faScaleUnbalancedFlip}
                        size="lg"
                        style={{
                          margin: '0 2px',
                          transform: 'scaleX(0.8)'
                        }}
                      />
                      <span style={{ fontSize: '0.8em' }}>▶</span>
                    </div>
                  )}
                </th>

                {payData.map((pay) => (
                  // Render a header column for each pay
                  <React.Fragment key={pay.id}>
                    <th colSpan="2" className="pay-header">
                      <div className="pay-nickname">
                        {pay.nickname}
                        {pay.canUseRemaining && (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                Remaining transfers allowed for this pay
                              </Tooltip>
                            }
                          >
                            <FontAwesomeIcon
                              icon={faChartPie}
                              size="sm"
                              style={{ color: '#6c757d' }}
                            />
                          </OverlayTrigger>
                        )}
                      </div>
                      <div className="pay-due" style={{ fontWeight: 'lighter' }}>
                        {pay.next_pay}
                      </div>
                      {editTransfers && (
                        <>
                      <div className={`switch-toggle-container ${pay.frequency === 'weekly' ? 'weekly-style' : ''}`}>
                        <input
                          type="checkbox"
                          id={`pay-toggle-${pay.id}`}
                          className="switch-toggle-input"
                          checked={pay.canUseRemaining}
                          onChange={() => handleToggleDesignatedPay(pay)}
                          disabled={pay.frequency === 'weekly'}
                        />
                        <label htmlFor={`pay-toggle-${pay.id}`} className="switch-toggle-label" />
                      </div>
                      <div style={{ fontWeight: 'lighter' }}>Allow Remaining</div>
                        </>
                      )}
                    </th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="totals-row subtitle-row">
                <td>total</td>
                <td>${totalFortnightlyRequirements.toFixed(2)}</td>
                <td
                  colSpan="2"
                  className={showAmounts ? 'amounts-expanded' : 'amounts-collapsed'}
                >
                  {(() => {
                    const totalPays = payData.reduce((sum, pay) => sum + parseFloat(pay.amount), 0);
                    const difference = totalPays - totalFortnightlyRequirements;

                    return (
                      <div className={`transfer-amount-group ${showAmounts ? 'amounts-expanded' : 'amounts-collapsed'} ${
                        difference !== 0 ? (difference < 0 ? 'transfer-amount-group-under' : 'transfer-amount-group-over') : ''
                      }`}>
                        <span>${totalPays.toFixed(2)}</span>
                        <span>{difference === 0 ? '' : `${difference < 0 ? '− ' : '+ '}${Math.abs(difference).toFixed(2)}`}</span>
                      </div>
                    );
                  })()}
                </td>
                {payData.map((pay) => (
                  <React.Fragment key={pay.id}>
                      <td
                          onClick={() => handlePayClick(pay)}
                          style={{ cursor: editTransfers ? 'pointer' : 'default' }}
                          colSpan="2">
                          <div>${parseFloat(pay.amount).toFixed(2)}</div>
                      </td>
                  </React.Fragment>
              ))}
            </tr>
            {bankAccounts.map((account) => (
              <tr className="data-row" key={account.id}>
                <td style={{ fontWeight: "bold" }}>{account.nickname}</td>
                <td
                  onClick={() => editTransfers && handleBankAccountClick(account)}
                  style={{ fontWeight: "bold", cursor: editTransfers ? 'pointer' : 'default' }}
                  title="Click to edit (when Edit Transfers is enabled)"
                >
                  ${(
                    // Backend now provides the correct fortnightly amount, no conversion needed
                    parseFloat(account.required_amount)
                  ).toFixed(2)}
                </td>
                <td colSpan="2">
                  {(() => {
                    const totalTransfers = payData
                      .flatMap(pay => pay.bank_accounts)
                      .filter(ba => ba.bank_account === account.id)
                      .reduce((total, ba) => total + parseFloat(ba.transfer_amount), 0);

                    // Backend now provides the correct fortnightly amount, no conversion needed
                    const requiredAmount = parseFloat(account.required_amount);

                    const difference = totalTransfers - requiredAmount;
                    const className = `transfer-amount-group ${
                      difference < 0 ? 'transfer-amount-group-under' :
                      difference > 0 ? 'transfer-amount-group-over' : ''
                    }`;

                    return (
                      <div className={difference === 0 ? 'transfer-amount-group' : className}>
                        <span>${totalTransfers.toFixed(2)}</span>
                        <span>{difference === 0 ? '' : `${difference < 0 ? '− ' : '+ '}${Math.abs(difference).toFixed(2)}`}</span>
                      </div>
                    );
                  })()}
                </td>
                {payData.map((pay) => {
                  const payBankAccount = pay.bank_accounts.find(
                    (bankAccount) => bankAccount.bank_account === account.id
                  );
                  if (!payBankAccount) {
                    // Return null or an empty fragment if payBankAccount is undefined
                    return null; // or <React.Fragment key={pay.id}></React.Fragment>
                  }
                  const transferAmount = payBankAccount ? parseFloat(payBankAccount.transfer_amount) : 0;
                  const transferOption = payBankAccount ? payBankAccount.transfer_option : '';

                    return (
                      <React.Fragment key={pay.id}>
                          <td
                              onClick={() => handleCellClick(payBankAccount, pay.id)}
                              className={`${
                                  transferOption === 'remaining'
                                      ? 'cell-remaining'
                                      : transferOption === 'unallocated'
                                      ? 'cell-unallocated'
                                      : ''
                              }`}
                              style={{ cursor: editTransfers ? 'pointer' : 'default' }}
                          >
                          {/* 	{payBankAccount ? payBankAccount.transfer_amount : 0} */}
                              {payBankAccount.transfer_amount !== '0.00' ? payBankAccount.transfer_amount : '-'}
                          </td>
                        <td>
                          {/* Render a button to identify transfer_made or not */}
                          {payBankAccount && parseFloat(payBankAccount.transfer_amount) !== 0 && (
                            <Button
                              variant={payBankAccount.transfer_made ? "outline-secondary" : "outline-warning"}
                              onClick={(e) => {
                                e.stopPropagation(); // Stop the event from reaching the parent cell click handler
                                handleButtonClick(payBankAccount);
                              }}
                            >
                              {payBankAccount.transfer_made ? '✓' : '✗'}
                            </Button>
                              )}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>

      {/* Modal for editing pays */}
      <Modal 
        show={showPayModal} 
        onHide={() => setShowPayModal(false)}
        size={isMobile ? "sm" : undefined}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? "16px" : undefined }}>
            Update Pay Amount for the{' '}
            <span style={{ fontWeight: 'bold' }}>
              {payNickname}
            </span>{' '}
            pay
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="payAmount">
              <Form.Label>Pay Amount</Form.Label>
              <Form.Control
                type="text"
                value={editedPayAmount}
                onChange={(e) => setEditedPayAmount(e.target.value)}
              />
            </Form.Group>
            <br />
            <Form.Group controlId="formApplyToAll">
              <Form.Check
                type="checkbox"
                label="Apply changes to all following Pays in series"
                checked={applyToAll}
                onChange={(e) => setApplyToAll(e.target.checked)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPayModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={() => updatePayClick(payId)}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for editing bank accounts required amount */}
      <Modal 
        show={showBankAccountModal} 
        onHide={() => setShowBankAccountModal(false)} 
        size={isMobile ? "lg" : "xl"}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? "16px" : undefined }}>
            Update Required Amount for the{' '}
            <span style={{ fontWeight: 'bold' }}>
              {bankAccountNickname}
            </span>{' '}
            account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center mb-3" style={{ fontStyle: 'italic' }}>
            All amounts below are <strong>fortnightly totals</strong>
          </p>
          {/* Dynamic duplicate bank account check */}
          {currentBankAccount && bankAccountNickname && (
            <DuplicateWarning bankAccountName={bankAccountNickname} bankAccountId={bankAccountId} />
          )}
          <Form>
            <Form.Group controlId="bankAccountReqTotal">
              <Form.Label>
                Requirements Total
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip>
                      Total calculated from requirements assigned to this bank account (fortnightly amount)
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: '5px', cursor: 'help' }}>
                    <BsInfoCircle size={14} />
                  </span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                type="text"
                value={typeof requirementsTotal === 'number' ? requirementsTotal.toFixed(2) : '0.00'}
                readOnly
              />
            </Form.Group>
            
            <Form.Group controlId="bankAccountAdjustment">
              <Form.Label>
                Adjustment Amount
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip>
                      Additional amount to add or subtract from the requirements total (fortnightly)
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: '5px', cursor: 'help' }}>
                    <BsInfoCircle size={14} />
                  </span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                type="text"
                inputMode="decimal"
                value={adjustmentAmount}
                onChange={(e) => handleAdjustmentChange(e.target.value)}
                onFocus={(e) => e.target.select()}
                placeholder="0.00 (use negative to reduce)"
              />
            </Form.Group>
            
            <Form.Group controlId="adjustmentReason">
              <Form.Label>Adjustment Reason</Form.Label>
              <Form.Control
                type="text"
                value={adjustmentReason}
                onChange={(e) => setAdjustmentReason(e.target.value)}
                placeholder="Reason for adjustment (optional)"
              />
            </Form.Group>
            
            <Form.Group controlId="bankAccountReqAmount">
              <Form.Label>
                <strong>Required Amount</strong>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip>
                      This is the total of Requirements + Adjustment, and will be used for transfers (fortnightly amount)
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: '5px', cursor: 'help' }}>
                    <BsInfoCircle size={14} />
                  </span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                type="text"
                value={typeof editedBankAccountReqAmount === 'number' ? editedBankAccountReqAmount.toFixed(2) : '0.00'}
                onChange={(e) => {
                  const value = parseFloat(e.target.value) || 0;
                  setEditedBankAccountReqAmount(value);
                }}
                style={{ fontWeight: 'bold' }}
              />
            </Form.Group>
            
            <hr className="my-3" />
            
            <div className="mb-3">
              <Form.Label className="d-block">
                <strong>Time Period</strong>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip>
                      How long this required amount should be effective
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: '5px', cursor: 'help' }}>
                    <BsInfoCircle size={14} />
                  </span>
                </OverlayTrigger>
              </Form.Label>
              
              <div className="mb-2 d-flex gap-2">
                <Button 
                  variant={amountChangeScope === 'one_fortnight' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => setAmountChangeScope('one_fortnight')}
                >
                  One Fortnight
                </Button>
                <Button 
                  variant={amountChangeScope === 'indefinite' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => setAmountChangeScope('indefinite')}
                >
                  Indefinite
                </Button>
                <Button 
                  variant={amountChangeScope === 'multiple_fortnights' ? 'primary' : 'outline-secondary'}
                  size="sm"
                  onClick={() => setAmountChangeScope('multiple_fortnights')}
                >
                  Multiple Fortnights
                </Button>
              </div>
            </div>
            
            <Form.Group controlId="bankAccountStartDate" className="mb-3">
              <Form.Label>
                Start Date (Fortnight Beginning)
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip>
                      Date when this required amount becomes effective (must be start of a fortnight)
                    </Tooltip>
                  }
                >
                  <span style={{ marginLeft: '5px', cursor: 'help' }}>
                    <BsInfoCircle size={14} />
                  </span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                as="select"
                value={editedBankAccountStartDate || ''}
                onChange={(e) => setEditedBankAccountStartDate(e.target.value)}
              >
                {getFortnightStartOptions().map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            
            {amountChangeScope === 'multiple_fortnights' && (
              <Form.Group controlId="amountChangeDuration" className="mb-3">
                <Form.Label>Number of Fortnights</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={amountChangeDuration}
                  onChange={(e) => setAmountChangeDuration(parseInt(e.target.value) || 1)}
                />
                {amountChangeDuration > 0 && editedBankAccountStartDate && (
                  <Form.Text className="text-muted">
                    Ends on: {formatDate(calculateEndDate(editedBankAccountStartDate, amountChangeDuration))}
                  </Form.Text>
                )}
              </Form.Group>
            )}
            
            {amountChangeScope === 'indefinite' && (
              <Form.Text className="text-muted mb-3">
                This amount will remain in effect until changed in the future.
              </Form.Text>
            )}
            
            {amountChangeScope === 'one_fortnight' && editedBankAccountStartDate && (
              <Form.Text className="text-muted mb-3">
                Effective for one fortnight only, from {formatDate(editedBankAccountStartDate)} to {formatDate(getFortnightEnd(editedBankAccountStartDate))}.
              </Form.Text>
            )}
            
            <Form.Group controlId="amountChangeReason" className="mt-2">
              <Form.Label>Reason for Change (Optional)</Form.Label>
              <Form.Control
                type="text"
                value={editedBankAccountReason}
                onChange={(e) => setEditedBankAccountReason(e.target.value)}
                placeholder="e.g., Temporary increase for holiday expenses"
              />
            </Form.Group>
            
            <div className="mt-4">
              <Button 
                variant="outline-secondary" 
                size="sm" 
                className="w-100"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAmountHistory(!showAmountHistory);
                }}
              >
                {showAmountHistory ? 'Hide Amount History' : 'Show Amount History'}
              </Button>
              
              {showAmountHistory && amountHistory.length > 0 && (
                <div className="mt-2 border rounded p-2">
                  <h6>Required Amount History</h6>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Amount</th>
                        <th>From</th>
                        <th>Until</th>
                      </tr>
                    </thead>
                    <tbody>
                      {amountHistory.map((period, idx) => (
                        <tr key={idx}>
                          <td>${parseFloat(period.total_required_amount).toFixed(2)}</td>
                          <td>{period.from_date ? formatDate(period.from_date) : 'Indefinite'}</td>
                          <td>{period.ongoing ? 'Ongoing' : (period.until_date ? formatDate(period.until_date) : 'Indefinite')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              
              {showAmountHistory && amountHistory.length === 0 && (
                <div className="mt-2 text-center text-muted">
                  No amount change history available
                </div>
              )}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {bankAccountSaveError && (
            <Alert variant="danger" className="w-100 mb-2 py-2">
              {bankAccountSaveError}
            </Alert>
          )}
          <Button variant="secondary" onClick={() => setShowBankAccountModal(false)}>
            Close
          </Button>
          <Button 
            variant="primary" 
            onClick={() => updateBankAccountClick(bankAccountId)}
            disabled={isUpdatingBankAccount}
          >
            {isUpdatingBankAccount ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Updating...
              </>
            ) : (
              'Save'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for editing transfer_option and transfer_amount */}
      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        size="sm"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? "16px" : undefined }}>
            Edit Transfer Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formTransferOption">
              <Form.Label>Transfer Option</Form.Label>
              <Form.Control
                as="select"
                value={editedTransferOption}
                onChange={(e) => setEditedTransferOption(e.target.value)}
              >
                <option value="fixed">Fixed</option>
                <option
                  value="remaining"
                  disabled={isRemainingOptionDisabled}
                >
                  {(isRemainingOptionDisabled)
                    ? '\'Allow Remaining\' is disabled for this Pay'
                    : 'Remaining'}
                </option>
                <option
                  value="unallocated"
                  disabled={isUnallocatedOptionDisabled}
                >
                  {isUnallocatedOptionDisabled
                    ? 'Unallocated (already used for this pay)'
                    : 'Unallocated'}
                </option>
              </Form.Control>
            </Form.Group>
            {editedTransferOption === 'fixed' && ( // Conditionally render based on transfer_option
              <Form.Group controlId="formTransferAmount">
                <Form.Label>Transfer Amount</Form.Label>
                <Form.Control
                  type="text"
                  value={editedTransferAmount}
                  onChange={(e) => setEditedTransferAmount(e.target.value)}
                />
              </Form.Group>
            )}
            <br />
            <Form.Group controlId="formApplyToAll">
              <Form.Check
                type="checkbox"
                label="Apply changes to all following Pays in series"
                checked={applyToAll}
                onChange={(e) => setApplyToAll(e.target.checked)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button 
            variant="primary" 
            onClick={() => saveChangesWrapper(payId)}
            disabled={isUpdatingPayBankAccount}
          >
            {isUpdatingPayBankAccount ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Saving...
              </>
            ) : (
              'Save'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for confirming change Pay with 'Allow Remaining' */}
      <Modal 
        show={showConfirmationModal} 
        onHide={() => setShowConfirmationModal(false)}
        size={isMobile ? "sm" : undefined}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? "16px" : undefined }}>
            Allow Remaining
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {remainingToggleValue ? 'Turn on' : 'Turn off'} <strong>Allow Remaining</strong>
            {remainingToggleTarget ? ` for ${remainingToggleTarget.nickname}` : ''}.
          </p>
          <Form.Group className="mb-3">
            <Form.Label>Apply to</Form.Label>
            <Form.Check
              type="radio"
              id="remaining-scope-this-pay"
              name="remainingScope"
              label="This pay only"
              checked={remainingScope === 'this_pay'}
              onChange={() => setRemainingScope('this_pay')}
            />
            <Form.Check
              type="radio"
              id="remaining-scope-future"
              name="remainingScope"
              label="This pay and future pays"
              checked={remainingScope === 'this_and_future'}
              onChange={() => setRemainingScope('this_and_future')}
            />
            <Form.Check
              type="radio"
              id="remaining-scope-period"
              name="remainingScope"
              label="Pays in a period"
              checked={remainingScope === 'pay_period'}
              onChange={() => setRemainingScope('pay_period')}
            />
          </Form.Group>
          {remainingScope === 'pay_period' && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>From date</Form.Label>
                <Form.Control
                  type="date"
                  value={remainingPeriodFrom}
                  onChange={(e) => setRemainingPeriodFrom(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>To date</Form.Label>
                <Form.Control
                  type="date"
                  value={remainingPeriodUntil}
                  onFocus={() => {
                    if (!remainingPeriodUntil) {
                      setRemainingPeriodUntil(remainingPeriodFrom);
                    }
                  }}
                  onChange={(e) => setRemainingPeriodUntil(e.target.value)}
                />
                <Form.Text className="text-muted">
                  Dates are inclusive. The to date starts blank and opens from the selected pay date.
                </Form.Text>
              </Form.Group>
            </>
          )}
          {remainingScope === 'this_and_future' && (
            <Alert variant="info">
              This will also apply to future auto-generated pays in this series, if auto-maintain is enabled.
            </Alert>
          )}
          <Alert variant="secondary">
            {remainingPreviewLoading
              ? 'Checking impacted pays...'
              : `This will update ${remainingPreviewCount} pay${remainingPreviewCount === 1 ? '' : 's'}.`}
          </Alert>
          {remainingToggleValue && (
            <Alert variant="warning">
              If another pay in an affected fortnight already allows remaining, that pay will be turned off and
              its remaining transfers will become fixed at their current amounts.
            </Alert>
          )}
          {!remainingToggleValue && (
            <Alert variant="info">
              Any remaining transfers in the selected scope will become fixed at their current amounts.
            </Alert>
          )}
          {remainingToggleError && <Alert variant="danger">{remainingToggleError}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmationModal(false)} disabled={remainingToggleBusy}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleConfirmToggleDesignatedPay()}
            disabled={remainingToggleBusy || (remainingScope === 'pay_period' && (!remainingPeriodFrom || !remainingPeriodUntil))}
          >
            {remainingToggleBusy ? 'Saving...' : 'Confirm'}
          </Button>
        </Modal.Footer>
      </Modal>

      {!isPhone && <TransferKey />}
      {!isPhone && (
      <div className="edit-transfers-toggle">
        <div style={{ fontWeight: 'lighter' }}>Edit Transfers</div>
        <div className="switch-toggle-container">
          <input
            type="checkbox"
            id={`edit-transfers-toggle`}
            className="switch-toggle-input"
            checked={editTransfers}
            onChange={() => setEditTransfers(!editTransfers)}
          />
          <label htmlFor={`edit-transfers-toggle`} className="switch-toggle-label" />
        </div>
      </div>
      )}


      {/* Mobile Account Details Overlay */}
      {showMobileAccountOverlay && selectedAccount && (
        <div className="mobile-account-overlay" onClick={() => setShowMobileAccountOverlay(false)}>
          <div className="mobile-account-overlay-content" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-account-overlay-header">
              <div className="mobile-account-overlay-title">{selectedAccount.nickname}</div>
              <button 
                className="mobile-account-overlay-close"
                onClick={() => setShowMobileAccountOverlay(false)}
              >
                ×
              </button>
            </div>
            <div className="mobile-account-details">
              <div className="mobile-account-detail-item">
                <span className="mobile-account-detail-label">Fortnightly Required:</span>
                <span className="mobile-account-detail-value">${selectedAccount.required_amount.toFixed(2)}</span>
              </div>
              <div className="mobile-account-detail-item">
                <span className="mobile-account-detail-label">Actual Amount:</span>
                <span className="mobile-account-detail-value">${selectedAccount.actual_amount.toFixed(2)}</span>
              </div>
              <div className="mobile-account-detail-item">
                <span className="mobile-account-detail-label">Difference:</span>
                <span className={`mobile-account-detail-value ${selectedAccount.difference >= 0 ? 'positive' : 'negative'}`}>
                  ${selectedAccount.difference.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      
    </div>
  );
};

export default TransferTable;
